module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Button ใช้สำหรับแสดงผลปุ่มลักษณะต่างๆ\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentBreadcrumb'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Breadcrumb\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentCard'
      }
    }
  }, [_vm._v("\n            Card   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#component-button"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Button\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Class ที่เกี่ยวข้อง")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-button")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-64px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class")]), _vm._v(" "), _c('th', [_vm._v("Option")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-button")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "_mgbt-32px"
  }, [_c('strong', [_vm._v("Color: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-primary")]), _vm._v(" (default),\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-accent")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-positive")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-negative")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-warning")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-info")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-white")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gray")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-dark")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-black")])]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-32px"
  }, [_c('strong', [_vm._v("State: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-loading")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-disabled")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Style: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-outline")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"bio-button\">.bio-button</div>\n<div class=\"bio-button -accent\">bio-button -accent</div>\n<div class=\"bio-button -positive\">bio-button -positive</div>\n<div class=\"bio-button -negative\">bio-button -negative</div>\n<div class=\"bio-button -info\">bio-button -info</div>\n<div class=\"bio-button -warning\">bio-button -warning</div>\n<div class=\"bio-button -white\">bio-button -white</div>\n<div class=\"bio-button -gray\">bio-button -gray</div>\n<div class=\"bio-button -dark\">bio-button -dark</div>\n<div class=\"bio-button -black\">bio-button -black</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-button _dp-ilb _mgbt-8px"
  }, [_vm._v(".bio-button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -accent _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -accent")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -positive _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -positive")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -negative")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -info _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -info")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -warning _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -warning")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -white _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -white")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -gray _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -gray")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -dark _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -dark")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -black _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -black")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน อื่นๆ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"bio-button\">.bio-button</div>\n<div class=\"bio-button -accent\">bio-button -accent</div>\n<div class=\"bio-button -positive\">bio-button -positive</div>\n<div class=\"bio-button -negative\">bio-button -negative</div>\n<div class=\"bio-button -info\">bio-button -info</div>\n<div class=\"bio-button -warning\">bio-button -warning</div>\n<div class=\"bio-button -white\">bio-button -white</div>\n<div class=\"bio-button -gray\">bio-button -gray</div>\n<div class=\"bio-button -dark\">bio-button -dark</div>\n<div class=\"bio-button -black\">bio-button -black</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-button -outline _dp-ilb _mgbt-8px"
  }, [_vm._v(".bio-button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -accent -outline _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -accent")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -positive -outline _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -positive")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative -outline _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -negative")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -info -outline _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -info")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -warning -outline _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -warning")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -white -outline _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -white")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -gray -outline _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -gray")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -dark -outline _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -dark")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -black -outline _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -black")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน อื่นๆ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"bio-button -accent\">Hello Button</div>\n<div class=\"bio-button -positive -loading\">Hello Button</div>\n<div class=\"bio-button -positive -disabled\">Hello Button</div>\n<div class=\"bio-button -positive -loading -disabled\">Hello Button</div>\n<div class=\"bio-button -positive -outline\">Hello Button</div>\n<div class=\"bio-button -positive -outline -loading\">Hello Button</div>\n<div class=\"bio-button -positive -outline -disabled\">Hello Button</div>\n<div class=\"bio-button -positive -outline -loading -disabled\">Hello Button</div>\n\n<div class=\"bio-button -negative\">Hello Button</div>\n<div class=\"bio-button -negative -loading\">Hello Button</div>\n<div class=\"bio-button -negative -disabled\">Hello Button</div>\n<div class=\"bio-button -negative -loading -disabled\">Hello Button</div>\n<div class=\"bio-button -negative -outline\">Hello Button</div>\n<div class=\"bio-button -negative -outline -loading\">Hello Button</div>\n<div class=\"bio-button -negative -outline -disabled\">Hello Button</div>\n<div class=\"bio-button -negative -outline -loading -disabled\">Hello Button</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-button -positive _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -positive -loading _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -positive -disabled _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -positive -loading -disabled _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "bio-button -positive -outline _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -positive -outline -loading _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -positive -outline -disabled _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -positive -outline -loading -disabled _dp-ilb _mgbt-32px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative -loading _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative -disabled _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative -loading -disabled _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative -outline _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative -outline -loading _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative -outline -disabled _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative -outline -loading -disabled _dp-ilb _mgbt-32px"
  }, [_vm._v("Hello Button")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02715751","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document-pages/ComponentButton.vue
// module id = 108
// module chunks = 0